export default "__VITE_PUBLIC_ASSET__49d687c5__"